import { Popover } from 'react-bootstrap';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';

export const PopoverWrapper = styled(Popover) <{ width?: string }>`
    max-width: ${p => p.width ? p.width : '600px'};
    
    & > div {
        font-size: 12px;
    }
`;

export const dashFullyUtilizedOverlay = (
    <PopoverWrapper>
        <div>DASH Intake Volume L 3 Months &gt;= LD TXP Volume Prior Year</div>
    </PopoverWrapper>
);

export const donorFollowupFullyUtilizedOverlay = (
    <PopoverWrapper>
        <div>Follow-up Registrations L 180 Days &gt; 50% of LY Qrtrly LD TXP Volume</div>
    </PopoverWrapper>
);

export const donorFollowupUtilizationOverlay = (
    <PopoverWrapper>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
            <div style={{ paddingRight: 10, textAlign: 'center' }}>
                <div style={{ borderBottom: '1px solid black' }}>Follow-up Registrations L 180 days</div>
                <div>LY Avg Qrtrly LD Volume</div>
            </div>
        </div>
    </PopoverWrapper>
);

export const donorShieldDirectFullyUtilizedOverlay = (
    <PopoverWrapper>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
            <div style={{ paddingRight: 10, textAlign: 'center' }}>
                <div style={{ borderBottom: '1px solid black' }}>DSD Registrations L 90 Days</div>
                <div>LY Avg Qrtrly LD Vol. - NKR TXP Vol. L 90 Days</div>
            </div>
            <div>&gt;= 70%</div>
        </div>
    </PopoverWrapper>
);

export const donorShieldDirectUtilizationOverlay = (
    <PopoverWrapper>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
            <div style={{ textAlign: 'center' }}>
                <div style={{ borderBottom: '1px solid black' }}>DSD Registrations L 90 Days</div>
                <div>LY Avg Qrtrly LD Vol. - NKR TXP Vol. L 90 Days</div>
            </div>
        </div>
    </PopoverWrapper>
);

export const micrositesFullyUtilizedOverlay = (
    <PopoverWrapper>
        <div>Microsite registrations &gt; 25% of the center's deceased donor waitlist</div>
    </PopoverWrapper>
);

export const micrositeUtilizationOverlay = (
    <PopoverWrapper>
        <div>
            <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
                <div style={{ paddingRight: 10, textAlign: 'center' }}>
                    <div style={{ borderBottom: '1px solid black' }}>Microsite Registrations</div>
                    <div>Deceased Donor Waitlist</div>
                </div>
            </div>
        </div>
    </PopoverWrapper>
);

export const pwlFullyUtilizedOverlay = (
    <PopoverWrapper>
        <ul style={{ paddingLeft: 20, marginBottom: 0 }}>
            <li style={{ fontSize: 12, marginBottom: 5 }}>Center uses PL DASH</li>
            <li style={{ fontSize: 12, marginBottom: 5 }}>Center uses PWL for All Candidates</li>
            <li>
                <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
                    <div style={{ paddingRight: 10, textAlign: 'center' }}>
                        <div style={{ borderBottom: '1px solid black' }}>PWL registrations L 3 Months</div>
                        <div>DASH registrations L 3 Months</div>
                    </div>
                    <div>&gt; 33%</div>
                </div>
            </li>
        </ul>
    </PopoverWrapper>
);

export const pwlUtilizationOverlay = (
    <PopoverWrapper>
        <div>
            <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
                <div style={{ paddingRight: 10, textAlign: 'center' }}>
                    <div style={{ borderBottom: '1px solid black' }}>PWL registrations L 3 Months</div>
                    <div>DASH registrations L 3 Months</div>
                </div>
            </div>
        </div>
    </PopoverWrapper>
);

export const voucherProgramUtilizationOverlay = (
    <PopoverWrapper>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
            <div style={{ paddingRight: 10, textAlign: 'center' }}>
                <div style={{ borderBottom: '1px solid black' }}>Donations L 12 months</div>
                <div>Voucher Donations L 12 months</div>
            </div>
        </div>
    </PopoverWrapper>
);

export const kflActiveOverlay = (
    <PopoverWrapper>
        <div>Center is using High Res and they have placed at least one order for a typing kit</div>
    </PopoverWrapper>
);

export const kflFullyUtilizedOverlay = (
    <PopoverWrapper width='700px'>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
            <div style={{ paddingRight: 10, textAlign: 'center' }}>
                <div style={{ borderBottom: '1px solid black' }}>Exportable Patients w/ High Res + TX Patients w/ High Res L 6 M</div>
                <div>TX Patients L 6 Months (except for non-Voucher Holder Chips) + Patients Exportable for at least 15 Days</div>
            </div>
            <div>{'>'}= 100%</div>
        </div>
    </PopoverWrapper>
);

export const kflUtilizationOverlay = (
    <PopoverWrapper>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
            <div style={{ paddingRight: 10, textAlign: 'center' }}>
                <div style={{ borderBottom: '1px solid black' }}>Exportable Patients w/ High Res Typing + TX Patients w/ High Res Typing L 6 M</div>
                <div>TX Patients L 6 Months (except for non-Voucher Holder Chips) + Patients Exportable for at least 15 Days</div>
            </div>
        </div>
    </PopoverWrapper>
);

export const kflSuccessOverlay = (
    <PopoverWrapper>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: 12 }}>
            <div style={{ paddingRight: 10, textAlign: 'center' }}>
                <div style={{ borderBottom: '1px solid black' }}>Total Low and 0 MM TXPs</div>
                <div>Total TXPs w/ High Res Typing</div>
            </div>
        </div>
    </PopoverWrapper>
);

export const kflLowMmTxpsOverlay = (
    <PopoverWrapper>
        Count of all Low and 0 eplet MM TXPs for the past 12 months
    </PopoverWrapper>
);

export const directStreamlinedSerologyCount = (
    <PopoverWrapper>
        # of orders within the last 90 days
    </PopoverWrapper>
)

export const homeBloodDrawCount = (
    <PopoverWrapper>
        Count of home blood draws within the last 3 months
    </PopoverWrapper>
)

export const notesOverlay = (notes: string) => (
    <PopoverWrapper>
        <div style={{ marginBottom: 10 }}>
            {notes != '' ?
                <>{ReactHtmlParser(notes != null ? notes.replace(/\n/g, '<br/>') : '')}</>
                :
                <>- no notes -</>
            }
        </div>
        <div className='alert alert-info text-center' style={{ padding: 3, marginBottom: 0 }}>
            click the cell to edit the center's notes
        </div>
    </PopoverWrapper>
)

export const donorReferralCount = (
    <PopoverWrapper>
        Count of DASH registrations where the history<br />was completed within the past 12 months
    </PopoverWrapper>
);